import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { ChatDetailModel } from 'model/modules/chat/chatList';
import ChatListItem from './ChatListItem';

interface Props extends PaginationListProps<ChatDetailModel> {
  onItemSelected: (item: ChatDetailModel) => void;
}

const ChatListLoaded: FC<Props> = ({
  items,
  isFetching,
  setPage,
  currentPage,
  pageCount,
  onItemSelected,
}) => {
  const { t } = useTranslation();

  let content;
  if (items.length > 0) {
    content = (
      <InfiniteScroll
        loadMore={() => {
          if (!isFetching && currentPage < pageCount) {
            setPage(currentPage + 1);
          }
        }}
        hasMore={!isFetching && currentPage < pageCount}
        loader={
          <Center p={5} key="loading">
            <Spinner />
          </Center>
        }
        useWindow={false}
        initialLoad={false}
      >
        <Box py="10px">
          {items.map((item) => {
            return (
              <ChatListItem
                chatName={item.name}
                key={item.id}
                {...item}
                isSelected={false}
                onClick={() => {
                  onItemSelected(item);
                }}
              />
            );
          })}
        </Box>
      </InfiniteScroll>
    );
  } else {
    content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
  }

  return (
    <Box width="100%" height="100%" overflowY="auto" overflowX="hidden">
      {content}
    </Box>
  );
};

export default ChatListLoaded;
